import type { Match } from '@uefadigital/panenka';
import { MatchDayType, MatchUnitSize } from '@uefadigital/panenka';
import clsx from 'clsx';
import { memo, useMemo } from 'react';

import type { HpMatchFinalOptions } from '../../app';

import MatchUnit from '@shared/MatchUnit';
import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

const legLabelMap = {
  [MatchDayType.FIRST_LEG.toUpperCase()]: '1stleg',
  [MatchDayType.SECOND_LEG.toUpperCase()]: '2ndleg',
} as const;

const SemiFinal = ({ options, options: { matchDay }, matches }: { options: HpMatchFinalOptions; matches: Match[] }) => {
  const t = useTranslateFn();
  const legLabelTag = legLabelMap[matchDay?.type.toUpperCase()];

  const label = useMemo(() => (legLabelTag ? `${t('phase_SF')}, ${t(legLabelTag)}` : t('phase_SF')), [legLabelTag, t]);

  const muOptions = useMemo(
    () =>
      ({
        ...options,
        hideRound: true,
      }) as HpMatchFinalOptions,
    [options],
  );

  if (!matches?.length) return null;

  return (
    <>
      <div className={clsx('pk-col pk-col--span-12 pk-d--flex', styles.label)}>{label}</div>
      {matches.map((match) => (
        <div key={match.id} className='pk-col pk-col--span-12 pk-col--span-md-6 pk-d--flex'>
          <MatchUnit
            className='pk-flex--grow-1'
            key={match.id}
            match={match}
            options={muOptions}
            size={MatchUnitSize.XL}
          />
        </div>
      ))}
    </>
  );
};

export default memo(SemiFinal);
